import { TextField, TextFieldProps } from "@mui/material";
import { forwardRef, useEffect, useState } from "react";
import { FormController } from "./Controller";

interface WrapperInputTextProps {
  name: string;
  label: string;
  placeholder?: string;
  value?: string | number;
  testid?: string;
  onChange?: any;
  disabled?: boolean;
  min?: number;
  step?: number;
}

const WrapperInputNumber = forwardRef(
  (
    {
      name,
      label,
      placeholder = "",
      value = "",
      testid = "jetest",
      onChange,
      min,
      step,
      ...props
    }: WrapperInputTextProps,
    ref: any
  ) => {
    const [inputValue, setInputValue] = useState(value !== null ? value : "");

    useEffect(() => {
      if (value !== inputValue) {
        setInputValue(value);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    return (
      <TextField
        ref={ref}
        placeholder={placeholder}
        name={name}
        type="number"
        label={label}
        variant="outlined"
        onFocus={(e) => e.target.select()}
        inputProps={{
          ...(testid && { "data-testid": testid }),
          min: min ?? "0",
          step: step ?? "1",
        }}
        // InputLabelProps={{ shrink: true }}
        style={{ width: "100%" }}
        value={inputValue}
        {...props}
        onChange={(e) => {
          setInputValue(e.target.value);
          onChange?.(e);
        }}
      />
    );
  }
);

interface InputNumberProps {
  name?: string;
  withControl?: boolean;
  label?: string;
  placeholder?: string;
  required?: boolean;
  value?: string | number;
  rules?: any;
  onChange?: any;
  min?: number;
  step?: number;
}
export const InputNumber = ({
  name,
  withControl = true,
  label,
  placeholder,
  required = false,
  value = "",
  rules = {},
  ...rest
}: InputNumberProps & TextFieldProps) => {
  if (withControl) {
    return (
      <FormController
        name={name}
        label={label}
        required={required}
        rules={rules}
      >
        {(props) => (
          <WrapperInputNumber {...rest} {...props} placeholder={placeholder} />
        )}
      </FormController>
    );
  }

  return (
    <WrapperInputNumber
      name={name}
      label={label}
      placeholder={placeholder}
      value={value ?? ""}
      {...rest}
    />
  );
};
